import { Component, OnInit } from '@angular/core';
import { Button } from '@infocert/ng-ui-kit/models/button';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-suspend',
  templateUrl: './suspend.component.html',
  styleUrls: ['./suspend.component.scss'],
  standalone: false,
})
export class SuspendPageComponent implements OnInit {
  showConfirmPopup = false;
  statusMessage = '';

  constructor(private translateService: TranslateService) {}

  get cardButton(): Button {
    return {
      label: this.translateService.instant('SUSPEND_PAGE.CARD_1.ACTION'),
      color: 'text',
      onClick: () => {
        this.showConfirmPopup = true;
      },
    };
  }

  onConfirmSuspend(): void {
    this.showConfirmPopup = false;
    this.statusMessage = this.translateService.instant(
      'SUSPEND_PAGE.CARD_1.STATUS_OPENING'
    );
    setTimeout(() => {
      this.statusMessage = this.translateService.instant(
        'COMMON.LOADING_IN_PROGRESS'
      );
    }, 700);
    setTimeout(() => {
      window
        .open(
          this.translateService.instant('SUSPEND_PAGE.CARD_1.LINK'),
          '_blank'
        )
        .focus();
    }, 1200);
  }

  ngOnInit(): void {}
}
